import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeframeMatchingComponent } from './component/timeframe-matching.component';
import { CommonTranslationModule } from '@sdbn/common';
import { CommonLayoutModule  } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CommonTranslationModule,
    CommonLayoutModule
  ],
  declarations: [
    TimeframeMatchingComponent]
})
export class TimeframeMatchingModule { }
